import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TasacionArchivo } from '../models/TasacionArchivo';

@Injectable({
  providedIn: 'root'
})
export class TarifasService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTarifasAll() {
    return this.http.get(this.myAppUrl + 'api/Tarifa/GetAll');
  }

  getTarifas() {
    return this.http.get(this.myAppUrl + 'api/Tarifa');
  }

  getTarifaByID(id:number) {
    return this.http.get(this.myAppUrl + 'api/Tarifa/'+ id);
  }

  createTarifa(tarifa:any) {
    return this.http.put(this.myAppUrl + 'api/Tarifa', tarifa);
  }

  updateTarifa(tarifa:any) {
    return this.http.post(this.myAppUrl + 'api/Tarifa', tarifa);
  }

  deleteTarifa(id:number) {
    return this.http.delete(this.myAppUrl + 'api/Tarifa/'+id);
  }
}
